// Path: ./src/app/components/ImageWithModal/styled.ts
import styled from "styled-components";

export const SmallImage = styled.img`
  cursor: pointer;
  border-radius: 10px;
  height: 161px;
  width: 161px;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99999999999999999;
`;

export const LargeImage = styled.img`
  max-width: 90%;
  max-height: 90%;
`;
